import { render, staticRenderFns } from "./DatePickerOnly.vue?vue&type=template&id=0f96a9b4&scoped=true&"
import script from "./DatePickerOnly.vue?vue&type=script&lang=js&"
export * from "./DatePickerOnly.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerOnly.vue?vue&type=style&index=0&id=0f96a9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96a9b4",
  null
  
)

export default component.exports